import { kebabToCamelCase } from "~/utils/common";

export type TTranslationItem = {
  key: string;
  translation: string;
};

const translationHasKey = (key: string) => (item: TTranslationItem) =>
  item.key === key;

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const $route = useRoute();
  const isEnglish = $route?.params?.lang === "en";

  const translations = config?.public?.translations;
  const defaultGeneralKey = isEnglish ? "defaultEn" : "default";
  const defaultSpecificKey = `${kebabToCamelCase($route.params?.cinemaslug)}${
    isEnglish ? "En" : ""
  }`;

  const generalTranslations = translations[defaultGeneralKey] ?? [];
  const specificTranslations = translations[defaultSpecificKey] ?? [];

  const getTranslate = (key: string): string => {
    const hasRequestedKey = translationHasKey(key);
    const specificTranslation =
      specificTranslations.find(hasRequestedKey)?.translation;
    const generalTranslation =
      generalTranslations.find(hasRequestedKey)?.translation;

    return specificTranslation || generalTranslation || key;
  };

  return {
    provide: {
      getTranslate,
    },
  };
});
